import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { useProject } from '../../hooks/ProjectContext';
import Iconify from '../../components/iconify';

const SECTIONS = [
  { icon: 'eva:layers-fill', title: 'Stratification', desc: 'VMD0018 procedure — satellite layers, clustering, strata map. Already available in the Stratification tool.' },
  { icon: 'eva:pin-fill', title: 'Sampling Plan', desc: 'Stratified random sampling design per VM0042 Sec 9 — points per stratum, minimum distance, spatial coverage.' },
  { icon: 'eva:thermometer-outline', title: 'Baseline SOC Measurement', desc: 'ESM method (VMD0021) — soil cores at sampling points, lab analysis, carbon stock per stratum.' },
  { icon: 'eva:activity-outline', title: 'Baseline Emissions', desc: '3-year look-back: schedule of activities, fuel/fertilizer/electricity inputs, GHG calculations.' },
  { icon: 'eva:file-text-outline', title: 'Complete PD + ERR-PD', desc: 'Finalize Project Description and projected Emission Reductions & Removals for VERRA registration.' },
];

export default function BaselinePage() {
  const { selectedProject } = useProject();

  return (
    <>
      <Helmet><title>Baseline | TERRRA</title></Helmet>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h4" gutterBottom>Baseline Establishment</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Per-site baseline measurement and PD completion for{' '}
          {selectedProject ? <strong>{selectedProject.code}</strong> : 'the selected project'}.
          Repeatable when adding new sites to the group project.
        </Typography>

        <Stack spacing={2}>
          {SECTIONS.map((s) => (
            <Card key={s.title} variant="outlined">
              <CardContent>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Iconify icon={s.icon} sx={{ width: 32, height: 32, color: 'text.secondary', flexShrink: 0 }} />
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">{s.title}</Typography>
                    <Typography variant="body2" color="text.secondary">{s.desc}</Typography>
                  </Box>
                  <Box sx={{ p: 2, border: '1px dashed', borderColor: 'divider', borderRadius: 1 }}>
                    <Typography variant="caption" color="text.disabled">Coming soon</Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>
    </>
  );
}
